import { render, staticRenderFns } from "./ExpiringTradieList.vue?vue&type=template&id=62d4e454&scoped=true"
import script from "./ExpiringTradieList.vue?vue&type=script&lang=js"
export * from "./ExpiringTradieList.vue?vue&type=script&lang=js"
import style0 from "./ExpiringTradieList.vue?vue&type=style&index=0&id=62d4e454&prod&lang=scss&scoped=true"
import style1 from "./ExpiringTradieList.vue?vue&type=style&index=1&id=62d4e454&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d4e454",
  null
  
)

export default component.exports